import '../conversation.css';

import PropTypes from 'prop-types';
import React from 'react';
function formatDateTime(date) {
    const options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        timeZoneName: 'short'
    };
    return new Intl.DateTimeFormat('en-US', options).format(new Date(date));
}
function Message(props){
    Message.propTypes = {
        time: PropTypes.any,
        user: PropTypes.any,
        message: PropTypes.any,
    };
    if(!props.user)
    {  return(

        <div className="media media-chat media-chat-direct">
            <img
                className="avatar"
                src="https://img.icons8.com/color/36/000000/administrator-male.png"
                alt="..."
            ></img>
            <div className="media-body ">
                <p>{props.message}</p>
                <p
                    className="meta"
                    style={{color:'#8b95a5',backgroundColor: 'transparent'}}
                ><time>{formatDateTime(props.time)}</time></p>
            </div>
        </div>
    );}
    else{
        return(
            <div className="media media-chat media-chat-reverse">
                <div className="media-body">
                    <p>{props.message}</p>
                    <p
                        className="meta"
                        style={{color:'#8b95a5'}}
                    ><time >{formatDateTime(props.time)}</time></p>
                </div>
            </div>
        );}
}

export default Message;

/* // <div id="msg-0" classNameName="msg float-right">
        //         <div classNameName="head"> {props.sender} </div>
        //         <p classNameName="body"> {props.message} </p>
        //         <div classNameName="footer"> {props.time} </div>
        // </div> */